var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { API_PATHS, legalDepositsTitlesDuplicateReviewId, legalDepositsTitlesIdDuplicateGroups, legalDepositsTitlesIdMerges, } from "../types/apiPaths";
import { MERGE_CANDIDATE_LIMIT } from "../types/titleMerge";
import { getHeaders } from "../utils/apiUtils";
// The merge endpoints return bare arrays while the older collection endpoints wrap them in `items`.
var readList = function (payload) {
    if (Array.isArray(payload))
        return payload;
    var wrapper = (payload !== null && payload !== void 0 ? payload : {});
    if (Array.isArray(wrapper.items))
        return wrapper.items;
    // An empty wrapped collection arrives without `items` at all - the module serializes non_empty.
    if (typeof wrapper.totalRecords === "number")
        return [];
    throw new Error("Unexpected collection payload");
};
var parseList = function (response, what) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!response.ok)
                    throw new Error("".concat(what, " error: ").concat(response.statusText));
                _a = readList;
                return [4 /*yield*/, response.json()];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
        }
    });
}); };
export var previewTitleMerge = function (kyInstance, survivorId, duplicateIds) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_MERGE_PREVIEW, { json: { survivorId: survivorId, duplicateIds: duplicateIds }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Merge preview error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var mergeTitles = function (kyInstance, survivorId, duplicateIds, previewFingerprint) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_MERGE, {
                    json: { survivorId: survivorId, duplicateIds: duplicateIds, previewFingerprint: previewFingerprint },
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Merge titles error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var fetchTitleMerges = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = parseList;
                return [4 /*yield*/, kyInstance.get(legalDepositsTitlesIdMerges(titleId), {
                        headers: getHeaders(),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), "Fetch title merges"])];
        }
    });
}); };
export var fetchDuplicateGroups = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = parseList;
                return [4 /*yield*/, kyInstance.get(legalDepositsTitlesIdDuplicateGroups(titleId), {
                        headers: getHeaders(),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), "Fetch duplicate groups"])];
        }
    });
}); };
export var createDuplicateReview = function (kyInstance, request) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_DUPLICATE_REVIEWS, { json: request, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create duplicate review error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var revokeDuplicateReview = function (kyInstance, reviewId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.delete(legalDepositsTitlesDuplicateReviewId(reviewId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Revoke duplicate review error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var fetchMergeCandidates = function (kyInstance_1, search_1, type_1, setIds_1) {
    var args_1 = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        args_1[_i - 4] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1, search_1, type_1, setIds_1], args_1, true), void 0, function (kyInstance, search, type, setIds, limit) {
        var searchParams, _a;
        if (limit === void 0) { limit = MERGE_CANDIDATE_LIMIT; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    searchParams = new URLSearchParams();
                    searchParams.append("search", search);
                    searchParams.append("type", type);
                    setIds.forEach(function (id) { return searchParams.append("setIds", id); });
                    searchParams.append("limit", limit.toString());
                    _a = parseList;
                    return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_TITLES_MERGE_CANDIDATES, {
                            searchParams: searchParams,
                            headers: getHeaders(),
                        })];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), "Fetch merge candidates"])];
            }
        });
    });
};
export var fetchTitleComparison = function (kyInstance, ids) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                searchParams = new URLSearchParams();
                ids.forEach(function (id) { return searchParams.append("ids", id); });
                _a = parseList;
                return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_TITLES_COMPARE, {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), "Fetch title comparison"])];
        }
    });
}); };
